import { defineComponent as _defineComponent } from 'vue'
import { LegacyRoccSeverity } from '@/ui/components/inspectionReport/legacyTypes';
  import { ref, computed, onMounted, getCurrentInstance } from 'vue';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { cloneDeep } from 'lodash/fp';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';
  import { Icon } from '@/ui/components/icon/Icon';
  import RoccSeverityEditor from '@/_legacy/views/ChecklistBuilder/Build/Components/RoccSeverityEditor.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditRoccSeverity',
  emits: ['close', 'save'],
  setup(__props, { emit }) {

  

  const instance = getCurrentInstance();
  const store = instance!.proxy.$store;

  const roccEnabled = ref(false);
  const severities = ref<Array<LegacyRoccSeverity>>([]);

  const categories = computed(() => store.getters['checklist_builder/categories']);
  const checklist = computed(() => store.getters['checklist_builder/checklist']);
  const formRoccEnabled = computed(() => checklist.value?.form?.params?.rocc_enabled || false);

  const item = computed(() => {
    const modal = store.getters['checklist_builder/edit_rocc_modal'];

    return modal?.item || null;
  });

  onMounted(() => {
    roccEnabled.value = item.value?.params?.rocc_enabled || false;
    severities.value = item.value?.params?.severities ? cloneDeep(item.value?.params?.severities) : [];
  });

  const handleRoccEnabledUpdate = (value: boolean) => {
    roccEnabled.value = value;

    if (!value) {
      severities.value = [];
    } else if (severities.value.length === 0) {
      severities.value.push({ category: null, threshold: 1 });
    }
  };

  const handleSeveritiesUpdate = (value: LegacyRoccSeverity[]) => {
    severities.value = value;
  };

  const handleClose = () => {
    emit('close');
  };

  const handleSave = () => {
    const invalids = severities.value
      .filter(severity => severity.category === null || severity.threshold < 1)
      .length;

    if (invalids) {
      toasted.error(t('template-builder.rocc.invalid-categories'));
      toasted.error(t('template-builder.rocc.invalid-negative-responses'));

      return;
    }

    emit('save', {
      roccEnabled: roccEnabled.value,
      severities: severities.value,
    });
  };

return { __sfc: true,emit, instance, store, roccEnabled, severities, categories, checklist, formRoccEnabled, item, handleRoccEnabledUpdate, handleSeveritiesUpdate, handleClose, handleSave, PageSubtitle, Tooltip, Icon, RoccSeverityEditor }
}

})